import * as React from 'react';
import { Button, Col, Modal, Row } from 'reactstrap';
import { ProjectTypeConfig } from 'src/components/shared/Input/ProjectTypeList';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { IProject, ProjectType } from 'src/model';
// import { deleteUser } from 'src/services';
import { StepIcon } from '../../StepIcon';
import { Svg } from '../../Svg';
import { CreateProjectFirstStepWithGlobalContext } from './CreateProjectFirstStep';
import { CreateProjectSecondStepWithGlobalContext } from './CreateProjectSecondStep';
import { CreateProjectThirdStepwithGlobalContext } from './CreateProjectThirdStep';

interface IProjectModalProps {
  isOpen: boolean;
  toggleCreateProjectModal: () => void;
  toggleLoginModal: () => void;
  toggleSignupConfirmationModal: () => void;
}

const CreateProjectModal: React.SFC<
  IProjectModalProps & IGlobalContextProps
> = ({
  context,
  isOpen,
  toggleCreateProjectModal,
  toggleLoginModal,
  toggleSignupConfirmationModal,
}) => {
  const { user } = context;
  const [state, setState] = React.useState({
    invalid: false,
    project: {
      description: '',
      projectType: [ProjectType.expertise_et_conseil],
      title: '',
    },
    stepNumber: 1,
  });

  const handleLoginClick = () => {
    toggleLoginModal();
  };

  const handleChange = (e: React.ChangeEvent<Element>) => {
    setState({
      ...state,
      project: {
        ...state.project,
        [(e.target as any).name]: (e.target as any).value,
      },
    });
  };



  /* A optimiser   **********************************************/
const handleChangeMultiFunctionalSkills = (functionalSkills: any) => {
  setState({
    ...state,
    project: {
      ...state.project,
      functionalSkills
    }, 
  });
};

const handleChangeMultiTechnicalSkills = (technicalSkills: any) => {
  setState({
    ...state,
    project: {
      ...state.project,
      technicalSkills
    }, 
  });
};

const handleChangeMultiplace = (place: any) => {
  setState({
    ...state,
    project: {
      ...state.project,
      place
    }, 
  });
};

const handleChangeMultiDeliverable = (deliverable: any) => {
  setState({
    ...state,
    project: {
      ...state.project,
      deliverable
    }, 
  });
};


const handleChangeMultiDuration = (duration: any) => {
  setState({
    ...state,
    project: {
      ...state.project,
      duration
    }, 
  });
};
/**************************************************************************/


  const handleClick = (id: string) => {
    const label = ProjectTypeConfig[id].label;
    const index = state.project.projectType.indexOf(label);
    const projectType = state.project.projectType.slice();

    if (index === -1) {
      if (projectType.length < 3) {
        projectType.push(label);
        setState({
          ...state,
          invalid: false,
          project: { ...state.project, projectType },
        });
      } else {
        setState({ ...state, invalid: true });
      }
    } else {
      if (projectType.length !== 1) {
        projectType.splice(index, 1);
        setState({
          ...state,
          invalid: false,
          project: { ...state.project, projectType },
        });
      }
    }
  };

  const handleDateChange = (date: Date) => {
    setState({
      ...state,
      project: {
        ...state.project,
        startingDate: date,
      },
    });
  };

  const handleLocationUpdate = (localisation: {
    label: string;
    location: { lat: number; lng: number };
  }) => {
    setState({
      ...state,
      project: {
        ...state.project,
        localisation,
      },
    });
  };

  const changeStep = (stepNumber: number) => {
    setState({ ...state, stepNumber });
  };

  const toggleModalWithDeleteUser = () => {
    if (context.isCreating) {
      // deleteUser();
      context.updateUser(true);
      context.toggleIsCreating();
      changeStep(1);
    }
    closeModal();
  };

  const closeModal = () => {
    setState({
      invalid: false,
      project: {
        description: '',
        projectType: [ProjectType.expertise_et_conseil],
        title: '',
      },
      stepNumber: 1,
    });
    toggleCreateProjectModal();
  };

  return (
    <Modal className='position-relative' isOpen={isOpen} >
      <Svg
        className='position-absolute'
        fill='success'
        width={280}
        height={210}
        opacity={0.2}
        src='bulle-popin'
        style={{ top: '-19px', left: '-15px' }}
      />
      <div className='d-flex justify-content-end p-3'>
        <Svg
          fill='dark'
          width={16}
          src='close'
          onClick={toggleModalWithDeleteUser}
        />
      </div>
      <div
        className='d-flex justify-content-between align-items-center pl-5 pr-5'
        style={{ zIndex: 1 }}
      >
        <h3>
          Déposez votre
          <br />
          projet
        </h3>
        {!user && (
          <div className='d-flex flex-column'>
            <span className='text-primary'>J'ai déjà un compte</span>
            <Button
              className='btn-sm text-uppercase text-white bg-primary border-0 mt-2'
              onClick={handleLoginClick}
            >
              Connexion
            </Button>
          </div>
        )}
      </div>
      <Row className='pl-5 pr-5 mt-4'>
        <Col xs='6' />
        {[1, 2, 3].map((stepNumber: number, key: number) => (
          <StepIcon
            key={key}
            activeFill='primary'
            fill='success'
            isActive={stepNumber === state.stepNumber}
            opacity={stepNumber <= state.stepNumber ? 1 : 0.5}
            src='step-bulle-popin'
            stepNumber={stepNumber}
          />
        ))}
      </Row>
      {state.stepNumber === 1 && (
        <CreateProjectFirstStepWithGlobalContext
          changeStep={changeStep}
          toggleCreateProjectModal={closeModal}
        />
      )}
      {state.stepNumber === 2 && (
        <CreateProjectSecondStepWithGlobalContext
          changeStep={changeStep}
          handleChange={handleChange}
          handleClick={handleClick}
          invalidProjectType={state.invalid}
          project={state.project as IProject}
          toggleCreateProjectModal={closeModal}
        />
      )}
      {state.stepNumber === 3 && (
        <CreateProjectThirdStepwithGlobalContext
          changeStep={changeStep}
          handleChange={handleChange}
          handleChangeMultiFunctionalSkills={handleChangeMultiFunctionalSkills}
          handleChangeMultiTechnicalSkills={handleChangeMultiTechnicalSkills}
          handleChangeMultiplace={handleChangeMultiplace}
          handleChangeMultiDeliverable={handleChangeMultiDeliverable}
          handleChangeMultiDuration={handleChangeMultiDuration}
          handleDateChange={handleDateChange}
          handleLocationUpdate={handleLocationUpdate}
          project={state.project as IProject}
          toggleCreateProjectModal={closeModal}
          toggleSignupConfirmationModal={toggleSignupConfirmationModal}
        />
      )}
    </Modal>
  );
};

export const CreateProjectModalWithGlobalContext = withGlobalContext(
  CreateProjectModal
);



// WEBPACK FOOTER //
// ./src/components/shared/Modals/CreateProjectModal/CreateProjectModal.tsx